import { ChangeEvent, FC, useEffect, useRef, useState } from 'react'
import styles from './CreateEstablishmentModal.module.css'
import { useMediaQuery } from 'react-responsive'
import { UploadImagesType } from '../../types'
import arrowLeft from '../../assets/icons/arrowLeft.svg'
import close from '../../assets/icons/close.svg'
import { useNavigate } from 'react-router-dom'
import { Formik, FormikValues } from 'formik'
import s from '../../styles/common/Form.module.css'
import CustomInput from '../../components/UI/CustomInput/CustomInput'
import UploadPhotoComponent from '../../components/UploadPhotoComponent/UploadPhotoComponent'
import exit from '../../assets/icons/trash.svg'
import { companiesPerPage, placesPerPage } from '../../constants/constants'
import CustomTextArea from '../../components/UI/CustomTextArea/CustomTextArea'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import * as yup from 'yup'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { getMe } from '../../redux/actions/meAction'
import { getDaDataCity } from '../../redux/actions/daDataAction'
import { waitTimer } from '../../utils/waitTimer'
import { Suggestion } from '../RegistrationPage/RegistrationPage'
import { getCompanies } from '../../redux/actions/companiesAction'
import { CompaniesType } from '../../redux/actions/types'
import { clearDadata } from '../../redux/reducers/daData/daDataSlice'
import {
  createEstablishment,
  getEstablishmentFromCompany,
  getEstablishments,
} from '../../redux/actions/establishmentsAction'
import PATH from '../../navigation/path'
import { useRequestStatus } from '../../hooks/useRequestStatus'
import { useDebounce } from '../../hooks/useDebounce'
import Select from 'react-select'
import { useToast } from '../../context/ToastContext'

export type CreatePlatformPagePropsType = {
  innCompany?: string
  setVisibleModal: (value: boolean) => void
}

const CreateEstablishmentModal: FC<CreatePlatformPagePropsType> = ({ setVisibleModal }) => {
  const [photos, setPhotos] = useState<UploadImagesType[]>([])
  const [photosFile, setPhotosFile] = useState<any>([])
  const [logo, setLogo] = useState<UploadImagesType[]>([])
  const [logoFile, setLogoFile] = useState<any[]>([])
  const [files, setFiles] = useState<any>([])

  const [city, setCity] = useState<string>('')
  const [citySuggestions, setCitySuggestions] = useState<Suggestion[]>([])
  const [cityError, setCityError] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  const [currentPage, setCurrentPage] = useState(1)
  const [companyId, setCompanyId] = useState<number>(-1)

  const formikRef = useRef<any>()

  const [search, setSearch] = useState<string>('')
  const [companyStatus, setCompanyStatus] = useState<any>('')
  const { showSuccess, showError } = useToast()
  const { userRole, token } = useAppSelector((state) => state.auth)
  const { error } = useAppSelector((state) => state.establishments)
  const { meData } = useAppSelector((state) => state.me)
  const { daDataCity } = useAppSelector((state) => state.daData)
  const { companies } = useAppSelector((state) => state.companies)

  const debouncedStatus = useRequestStatus(companyStatus)
  const debounced = useDebounce(search, 1000)

  const [loaded, setLoaded] = useState<boolean>(false)

  const [sizeErrorText, setSizeErrorText] = useState<string>('')

  const dispatch = useAppDispatch()

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  const navigate = useNavigate()

  const clearAllInputs = () => {
    setCity('')
    setCitySuggestions([])
    setPhotos([])
    setPhotosFile([])
    setFiles([])
    setCompanyId(-1)
    setSearch('')
    setCompanyStatus('')
    setErrorMessage('')
    setSizeErrorText('')
    dispatch(clearDadata())
  }

  const handleCloseModal = () => {
    setVisibleModal(false)
    clearAllInputs()
    formikRef.current?.resetForm()
  }

  const onRedirectBack = () => {
    navigate(-1)
  }

  const validationSchema = yup.object().shape({
    platformName: yup.string().required('Поле является обязательным'),
    address: yup.string().required('Поле является обязательным'),
  })

  const handleCityInputChange = async (value: string) => {
    setCity(value)

    if (value.trim().length >= 1) {
      await dispatch(getDaDataCity({ query: city }))
    } else {
      setCitySuggestions([])
    }
  }

  const handleSelectSuggestion = (selectedCity: string) => {
    setCity(selectedCity)
    setCitySuggestions([])
  }

  const handleSubmitHandler = async (values: FormikValues) => {
    const _companyId =
      userRole === 'superAdmin' || userRole === 'admin' ? companyId : meData.company.id
    const name = values.platformName
    const address = values.address
    const size = values.capacity
    const logo = values.logo
    const description = values.description
    // const establishment = values.establishmentName

    const formData = new FormData()

    const maxSizeInBytes = 20 * 1024 * 1024

    for (let i = 0; i < photosFile.length; i++) {
      const sizeInBytes = photosFile[i].size

      if (sizeInBytes >= maxSizeInBytes) {
        setSizeErrorText(
          'Одна или несколько картинок слишком большие. Максимальный' + ' размер: 20 МБ.',
        )
        return
      }
    }

    if (city === '') {
      setCityError('Пожалуйста выберите город вашей организации')
      waitTimer(() => setCityError(''))
      return
    }

    if (photosFile) {
      for (let i = 0; i < photosFile.length; i++) {
        formData.append('images', photosFile[i])
      }
    }
    if (logoFile) {
      for (let i = 0; i < logoFile.length; i++) {
        formData.append('logo', logoFile[i])
      }
    }

    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i])
      }
    }
    formData.append('name', name)
    formData.append('logo', logo)
    formData.append('city', city)
    formData.append('address', address)
    formData.append('size', size)
    formData.append('description', description)
    formData.append('companyId', String(_companyId))

    setLoaded(true)
    const resultAction = await dispatch(createEstablishment({ formData, token }))

    if (createEstablishment.fulfilled.match(resultAction)) {
      setLoaded(false)
      clearAllInputs()
      if (userRole === 'directorPlace' || userRole === 'directorAgent') {
        dispatch(getEstablishmentFromCompany({ token, page: 1, itemsPerPage: placesPerPage }))
      } else {
        dispatch(getEstablishments({ token, page: 1, itemsPerPage: placesPerPage }))
      }
      handleCloseModal()
      navigate(PATH.establishmentPage)
      showSuccess('Площадка успешно создана')
    } else {
      setLoaded(false)
      showError('Произошла ошибка при создании площадки')
    }
  }

  useEffect(() => {
    setCitySuggestions(daDataCity)
  }, [daDataCity])

  useEffect(() => {
    if (userRole !== 'superAdmin' && userRole !== 'admin') {
      dispatch(getMe({ token }))
    }
  }, [dispatch, token])

  useEffect(() => {
    dispatch(
      getCompanies({
        token,
        page: currentPage,
        itemsPerPage: companiesPerPage,
        role: debouncedStatus,
      }),
    )
  }, [dispatch, currentPage, setCurrentPage, companiesPerPage, debounced, debouncedStatus])

  useEffect(() => {
    if (error) {
      setErrorMessage(error)
    }
  }, [error])

  const dummyData = (array: CompaniesType[]) => {
    const items: any[] = array.map((company) => {
      return {
        id: company.id,
        title: company.name,
      }
    })
    return items
  }

  return (
    <div className={styles.createPlatformPage}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.arrowLeftBlock} onClick={onRedirectBack}>
            <img className={styles.arrowLeft} src={arrowLeft} alt='arrowLeft' />
          </div>
          <div className={styles.titleBlock}>
            <h1 className={styles.title}>Создание площадки</h1>
            <img
              onClick={() => {
                handleCloseModal()
              }}
              className={styles.close}
              src={close}
              alt='close'
            />
          </div>
        </div>
      </div>
      <div className={styles.form}>
        <Formik
          innerRef={formikRef}
          initialValues={{
            images: [],
            logo: null,
            platformName: '',
            companyName: '',
            address: '',
            color: '',
            description: '',
            files: [],
            establishmentName: '',
          }}
          validateOnBlur
          onSubmit={(values) => {
            handleSubmitHandler(values)
          }}
          validationSchema={validationSchema}
        >
          {(props) => {
            const {
              values,
              touched,
              setFieldValue,
              errors,
              isValid,
              handleChange,
              handleBlur,
              handleSubmit,
            } = props

            const handleDeleteImage = (e: any) => {
              const targetIndex = e.target.dataset.imgindex * 1
              setPhotos([...photos.slice(0, targetIndex), ...photos.slice(targetIndex + 1)])
              setPhotosFile([
                ...photosFile.slice(0, targetIndex),
                ...photosFile.slice(targetIndex + 1),
              ])
              setFieldValue('images', [
                ...values.images.slice(0, targetIndex),
                ...values.images.slice(targetIndex + 1),
              ])
            }

            return (
              <div className={styles.formContainer}>
                <div className={styles.imageUpload}>
                  <UploadPhotoComponent
                    editMode
                    photos={photos}
                    photosFile={photosFile}
                    setPhotos={setPhotos}
                    widthOneImageContainer={245}
                    widthOneGapOfImageContainer={20}
                    setPhotosFiles={setPhotosFile}
                  >
                    <div className={styles.imagesWrapper}>
                      {photos.length > 0 &&
                        photos.map((photo, index) => {
                          return (
                            <div
                              className={styles.imagesContainer}
                              key={index}
                              data-imgindex={index}
                            >
                              <div className={styles.imageExitContainer}>
                                <img
                                  className={styles.imageExit}
                                  src={exit}
                                  alt='exit'
                                  onClick={handleDeleteImage}
                                  data-imgindex={index}
                                />
                              </div>
                              <img className={styles.image} src={photo?.src} alt={photo.name} />
                            </div>
                          )
                        })}
                    </div>
                  </UploadPhotoComponent>
                </div>
                <div className={styles.shortInformationBlock}>
                  <div className={styles.shortInformationContent}>
                    <div className={styles.inputBlock}>
                      <div className={styles.leftBlock}>Город</div>
                      <div className={styles.rightBlock}>
                        <CustomInput
                          type='text'
                          placeholder='Введите'
                          name='city'
                          required
                          onChange={(e: ChangeEvent<HTMLInputElement>) =>
                            handleCityInputChange(e.target.value)
                          }
                          value={city}
                          className={cityError ? `${s.input} ${s.inputError}` : s.input}
                        />
                        <ul className={styles.suggestionsDropdown}>
                          {citySuggestions.map((suggestion: Suggestion, index: number) => (
                            <li
                              key={index}
                              onClick={() => handleSelectSuggestion(suggestion.data.city)}
                            >
                              {suggestion.data.city}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div className={styles.inputBlock}>
                      <div className={styles.leftBlock}>Адрес</div>
                      <div className={styles.rightBlock}>
                        <CustomInput
                          type='text'
                          placeholder='Введите'
                          name='address'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.address}
                          className={
                            errors.address && touched.address
                              ? `${s.inputError} ${styles.input}`
                              : styles.input
                          }
                        />
                        {touched.address && errors.address && (
                          <p className={s.errorValidation}>{errors.address}</p>
                        )}
                      </div>
                    </div>
                    <div className={styles.inputBlock}>
                      <div className={styles.leftBlock}>Название площадки</div>
                      <div className={styles.rightBlock}>
                        <CustomInput
                          type='text'
                          placeholder='Введите'
                          name='platformName'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.platformName}
                          className={
                            errors.platformName && touched.platformName
                              ? `${s.inputError} ${styles.input}`
                              : styles.input
                          }
                        />
                        {touched.platformName && errors.platformName && (
                          <p className={s.errorValidation}>{errors.platformName}</p>
                        )}
                      </div>
                    </div>

                    {userRole === 'superAdmin' && (
                      <div className={styles.inputBlock}>
                        <div className={styles.leftBlock}>Компания</div>
                        <div className={styles.rightBlock}>
                          <Select
                            name='companyName'
                            required
                            options={dummyData(companies.companies).map((company) => ({
                              value: company.title,
                              label: company.title,
                              id: company.id,
                            }))}
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                border: 'none',
                                boxShadow: 'none',
                                minHeight: 'auto',
                                backgroundColor: 'transparent',
                              }),
                              menu: (provided) => ({
                                ...provided,
                                right: 0,
                                overflow: 'auto',
                                height: '150px',
                              }),
                              menuList: (provided) => ({
                                ...provided,
                                maxHeight: '150px',
                                overflowY: 'auto',
                              }),
                              input: (provided) => ({
                                ...provided,
                                margin: 0,
                                padding: 0,
                                height: isMobile ? 44 : 20,
                              }),
                              valueContainer: (provided) => ({
                                ...provided,
                                padding: 0,
                              }),
                              dropdownIndicator: (provided) => ({
                                ...provided,
                                padding: 0,
                              }),
                              clearIndicator: (provided) => ({
                                ...provided,
                                padding: 0,
                              }),
                              indicatorSeparator: () => ({
                                display: 'none',
                              }),
                            }}
                            onChange={(selectedOption) => {
                              if (selectedOption) {
                                const selectedCompany = dummyData(companies.companies).find(
                                  (company) => company.title === selectedOption.value,
                                )

                                if (selectedCompany) {
                                  setCompanyId(selectedCompany.id)
                                }

                                handleChange({
                                  target: {
                                    name: 'companyName',
                                    value: selectedOption.value,
                                  },
                                })
                              } else {
                                handleChange({
                                  target: {
                                    name: 'companyName',
                                    value: '',
                                  },
                                })
                                setCompanyId(0)
                              }
                            }}
                            onBlur={() => {
                              handleBlur({
                                target: {
                                  name: 'companyName',
                                },
                              })
                            }}
                            value={
                              values.companyName
                                ? {
                                    value: values.companyName,
                                    label: values.companyName,
                                  }
                                : null
                            }
                            classNamePrefix='react-select'
                            isClearable
                            className={styles.selectInput}
                            placeholder='Выберите компанию'
                            noOptionsMessage={() => 'Нет доступных компаний'}
                          />
                        </div>
                      </div>
                    )}
                    <div className={styles.inputBlock}>
                      <h2 className={styles.leftBlock}>Описание</h2>
                      <div className={styles.rightBlock}>
                        <div className={styles.inputBlock}>
                          <CustomTextArea
                            withoutFile
                            placeholder='Введите описание площадки'
                            name='description'
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.description}
                            className={
                              errors.description && touched.description
                                ? `${s.inputError} ${styles.input}`
                                : styles.input
                            }
                          ></CustomTextArea>
                          {touched.description && errors.description && (
                            <p className={s.errorValidation}>{errors.description}</p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={styles.logoUploadContainer}>
                      <UploadPhotoComponent
                        htmlFor='logo'
                        editMode
                        photos={logo}
                        photosFile={logoFile}
                        setPhotos={setLogo}
                        widthOneImageContainer={245}
                        widthOneGapOfImageContainer={20}
                        setPhotosFiles={setLogoFile}
                        hideInputIfHasValue={true}
                        hasLocalFiles={logo.length > 0 || logoFile.length > 0}
                      >
                        {logo.map((photo, index) => (
                          <div className={styles.imagesContainer} key={index} data-imgindex={index}>
                            <div className={styles.imageExitContainer}>
                              <img
                                className={styles.imageExit}
                                src={exit}
                                alt='exit'
                                onClick={handleDeleteImage}
                                data-imgindex={index}
                              />
                            </div>
                            <img className={styles.image} src={photo?.src} alt={photo.name} />
                          </div>
                        ))}
                      </UploadPhotoComponent>
                    </div>
                  </div>
                </div>

                {cityError && (
                  <p
                    style={{ marginBottom: 20 }}
                    className={`${s.errorValidation} ${s.networkError}`}
                  >
                    {cityError}
                  </p>
                )}

                {errorMessage && (
                  <p
                    style={{ marginBottom: 20 }}
                    className={`${s.errorValidation} ${s.networkError}`}
                  >
                    {errorMessage}
                  </p>
                )}
                {sizeErrorText && (
                  <p
                    style={{ marginBottom: 20 }}
                    className={`${s.errorValidation} ${s.networkError}`}
                  >
                    {sizeErrorText}
                  </p>
                )}
                <div className={styles.footerContainer}>
                  <div className={s.buttonGroup}>
                    <CustomButton
                      className={styles.submitBtn}
                      title='Создать'
                      disabled={!isValid}
                      onClick={() => handleSubmit()}
                      type='submit'
                    />
                  </div>
                </div>
              </div>
            )
          }}
        </Formik>
      </div>
    </div>
  )
}

export default CreateEstablishmentModal
